import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function BoldIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "10.62"}
      height={height || "14"}
      viewBox="0 0 10.62 14"
    >
      <path
        id="Path_10406"
        data-name="Path 10406"
        d="M9.3-7.141a3.136,3.136,0,0,1,1.94,1.183A3.462,3.462,0,0,1,12-3.751a3.563,3.563,0,0,1-.55,1.976A3.665,3.665,0,0,1,9.86-.441,5.811,5.811,0,0,1,7.4.04H1.38v-14H7.14a5.959,5.959,0,0,1,2.45.461,3.491,3.491,0,0,1,1.56,1.284,3.368,3.368,0,0,1,.53,1.865A3.2,3.2,0,0,1,11.03-8.3,3.477,3.477,0,0,1,9.3-7.141ZM4.18-8.183H6.74a2.339,2.339,0,0,0,1.54-.451,1.591,1.591,0,0,0,.54-1.294,1.621,1.621,0,0,0-.54-1.3,2.3,2.3,0,0,0-1.54-.461H4.18ZM7-2.247a2.391,2.391,0,0,0,1.59-.481,1.687,1.687,0,0,0,.57-1.364,1.759,1.759,0,0,0-.6-1.414,2.415,2.415,0,0,0-1.62-.511H4.18v3.771Z"
        transform="translate(-1.38 13.96)"
        fill={color || "#333"}
      />
    </svg>
  );
}
